import { useMeetingsService } from "../services/meetings.service";




export function useDownloadFile() {
    const { getMeetingIcs } = useMeetingsService()

  const handleDownloadIcs = async (meetingId: number) => {
    const blob = await getMeetingIcs(meetingId);

    if(!blob) return;
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `invite_${meetingId}.ics`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return { handleDownloadIcs };
}